import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Projects from "./components/Projects/Projects";
import Footer from "./components/Footer";
import Resume from "./components/Resume/ResumeNew";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import AdminPanel from "./components/Admin/AdminPanel";
import AdminHome from "./components/Admin/pages/Home";
import AdminSettings from "./components/Admin/pages/Settings";
import AdminUserProfile from "./components/Admin/pages/UserProfile";
import { auth } from "./firebase";

function App() {
  const [load, upadateLoad] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) {
        setUser(user);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);
  useEffect(() => {
    const timer = setTimeout(() => {
      upadateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/project" element={<Projects />} />
          <Route path="/about" element={<About />} />
          <Route path="/resume" element={<Resume />} />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/admin" element={user ?<AdminPanel />:<Navigate to="/" />} >
            <Route path="AdminHome" element={<AdminHome />} />
            <Route path="Adminsettings" element={<AdminSettings />} />
            <Route path="Adminuser" element={<AdminUserProfile />} />
          </Route>

        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
